"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onSelectedCrewOn = exports.onLeave = exports.getIsLoaded = exports.getMatchingTorpedoLauncher = exports.crewUpdate = void 0;
var assert_sidecar_1 = require("@lib/assert-sidecar");
var common_sidecar_1 = require("@main/common-sidecar");
var voyageMessageCrewCarry_1 = require("@voyage/multi/voyageMessageCrewCarry");
var voyageMessageCrewCarry_sidecar_1 = require("@voyage/multi/voyageMessageCrewCarry-sidecar");
var voyageMessageWeaponCommand_1 = require("@voyage/multi/voyageMessageWeaponCommand");
var voyageMessageWeaponCommand_sidecar_1 = require("@voyage/multi/voyageMessageWeaponCommand-sidecar");
var voyageCarryableData_1 = require("@voyage/entities/voyageCarryableData");
var diveCrew_sidecar_1 = require("@voyage/crew/diveCrew-sidecar");
var diveCrew_hero_sidecar_1 = require("@voyage/crew/diveCrew_hero-sidecar");
var voyageTilemap_sidecar_1 = require("@voyage/tilemap/voyageTilemap-sidecar");
var voyageUiSubsystem_sidecar_1 = require("@voyage/ui/voyageUiSubsystem-sidecar");
var voyageWebsockets_sidecar_1 = require("@voyage/multi-sockets/voyageWebsockets-sidecar");
function crewUpdate(obj) {
    var ds = common_sidecar_1.common.getUpdateDeltaScaled();
    var d = obj.heroState;
    assert_sidecar_1.assert.notNil(d);
    var useSystemTime = 1;
    d.useSystemTimer += ds;
    diveCrew_hero_sidecar_1.diveCrew_hero.setProgress(obj, d.useSystemTimer / useSystemTime);
    if (d.useSystemTimer > useSystemTime) {
        d.useSystemTimer -= useSystemTime;
        var tHere = voyageTilemap_sidecar_1.voyageTilemap.getSafeIJ(obj);
        if (tHere) {
            var tLauncher = getMatchingTorpedoLauncher(tHere);
            var isLoaded = getIsLoaded(tHere);
            if (tLauncher && tLauncher.system) {
                if (isLoaded) {
                    diveCrew_sidecar_1.diveCrew.say(obj, 'Already loaded');
                }
                else {
                    var torpedo = diveCrew_sidecar_1.diveCrew.getItemSafe(obj, voyageCarryableData_1.EVoyageCarryableType.Torpedo);
                    if (torpedo) {
                        if (voyageWebsockets_sidecar_1.voyageWebsockets.getIsHost()) {
                            voyageMessageWeaponCommand_sidecar_1.voyageMessageWeaponCommand.sendMessageAndImmediatelyExecute({
                                command: voyageMessageWeaponCommand_1.EWeaponCommand.Load,
                                systemId: tLauncher.system.id,
                                crewId: obj.id,
                            });
                            voyageMessageCrewCarry_sidecar_1.voyageMessageCrewCarry.sendMessageAndImmediatelyExecute({
                                command: voyageMessageCrewCarry_1.EVoyageCrewCarryCommand.Destroy,
                                carryId1: torpedo.id,
                                carryId2: 0,
                                crewId: obj.id,
                                i: obj.i,
                                j: obj.j,
                                type: voyageCarryableData_1.EVoyageCarryableType.Torpedo,
                            });
                        }
                    }
                    else {
                        diveCrew_sidecar_1.diveCrew.say(obj, 'I am not carrying a torpedo');
                    }
                }
            }
        }
    }
}
exports.crewUpdate = crewUpdate;
function getMatchingTorpedoLauncher(tile) {
    return voyageTilemap_sidecar_1.voyageTilemap.getSystemByKeySafe(tile.text3.replace('loader-', 'torpedo-'));
}
exports.getMatchingTorpedoLauncher = getMatchingTorpedoLauncher;
function getIsLoaded(tile) {
    var tLauncher = getMatchingTorpedoLauncher(tile);
    if (tLauncher.system) {
        if (tLauncher.system.ammo > 0) {
            return true;
        }
    }
    return false;
}
exports.getIsLoaded = getIsLoaded;
function onLeave(obj) {
    voyageUiSubsystem_sidecar_1.voyageUiSubsystem.setOpen(false);
}
exports.onLeave = onLeave;
function onSelectedCrewOn(obj) {
    voyageUiSubsystem_sidecar_1.voyageUiSubsystem.setOpen(true, obj.tile);
}
exports.onSelectedCrewOn = onSelectedCrewOn;
